/* eslint-disable */
<template>
    <div class="info-panel" ref="infoPanel">
        <a href="#" @click.prevent="transitionOut" class="close-button"
            ><svg viewBox="0 0 7.8 7.8" xmlns="http://www.w3.org/2000/svg">
                <path d="m3.01 0h1.78v7.8h-1.78z" />
                <path d="m3.01 0h1.78v7.8h-1.78z" transform="matrix(0 1 -1 0 7.8 0)" /></svg
        ></a>
        <div class="info-content" ref="infoContent">
            <h3>Project Year</h3>
            <h2 v-html="getYearLabel(projectYear)"></h2>
            <h3>Project Location</h3>
            <h2 v-html="projectTitle"></h2>
            <div class="project-image" ref="smallImage">
                <img :src="assetUrl + 'images/projects/' + projectImage" alt="Project Image" v-if="projectImage" />
            </div>
            <h3>Project Details</h3>
            <p v-html="projectDescription"></p>
            <a :href="linkUrl" class="project-button" target="_blank">
                <span>{{ buttonLabel }}</span>
                <svg v-if="projectStory" class="arrow-icon" viewBox="0 0 172.43 242.72" xmlns="http://www.w3.org/2000/svg">
                    <path d="m70.3 121.36-70.3-70.3 51.06-51.06 121.37 121.36-121.37 121.36-51.06-51.06z"></path>
                </svg>
                <svg v-else class="email-icon" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="m20.016 8.016v-2.016l-8.016 5.016-8.016-5.016v2.016l8.016 4.969zm0-4.032q.797 0 1.383.609t.586 1.406v12q0 .797-.586 1.406t-1.383.609h-16.031q-.797 0-1.383-.609t-.586-1.406v-12q0-.797.586-1.406t1.383-.609h16.031z"
                        fill="#fff"
                    />
                </svg>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        selectedProject: {
            type: Object,
            default: null
        }
    },

    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_URL,
            assetUrl: process.env.VUE_APP_ASSET_URL,
            projectYear: null,
            projectTitle: null,
            projectImage: null,
            projectUrl: null,
            projectDescription: null,
            projectStory: null,
            isOpen: false,

            emailAddress: 'jbandinfo@thgrp.com',
            emailSubject: 'Info Request:',
            emailBodyStart: 'Hi,\n\nI was exploring the J-Band Project Locator. I’m interested in more information about the specific project: “',
            emailBodyEnd: '”.\n\nThanks in advance for the information.'
        };
    },

    watch: {
        selectedProject: {
            immediate: true,
            handler(newVal, oldVal) {
                if (!oldVal && !newVal) return; // Hasn't been initted yet.

                if (!newVal) {
                    this.transitionOut();
                } else {
                    this.transitionIn();
                }
            }
        }
    },

    computed: {
        linkUrl() {
            let url;

            if (this.projectStory) {
                url = this.projectUrl;
            } else {
                url =
                    'mailto:' +
                    this.emailAddress +
                    '?subject=' +
                    encodeURIComponent(this.emailSubject) +
                    '%20' +
                    encodeURIComponent(this.projectTitle) +
                    '%20-%20' +
                    encodeURIComponent(this.getYearLabel(this.projectYear)) +
                    '&body=' +
                    encodeURIComponent(this.emailBodyStart) +
                    encodeURIComponent(this.projectTitle) +
                    '%20-%20' +
                    encodeURIComponent(this.getYearLabel(this.projectYear)) +
                    encodeURIComponent(this.emailBodyEnd);
            }

            return url;
        },

        buttonLabel() {
            let label;

            if (this.projectStory) {
                label = 'View Project';
            } else {
                label = 'Request More Info';
            }

            return label;
        }
    },

    methods: {
        transitionIn() {
            if (this.isOpen) {
                this.$nextTick(() => {
                    // 1. Fade out current data
                    TweenLite.to(this.$refs['infoContent'], 0.4, {
                        autoAlpha: 0,
                        transform: 'translateX(-15px)',
                        ease: Cubic.easeInOut,
                        force3D: true,
                        onComplete: () => {
                            // 2. Update content
                            this.projectYear = this.selectedProject.year;
                            this.projectTitle = this.selectedProject.title;
                            this.projectImage = this.selectedProject.image;
                            this.projectUrl = this.selectedProject.url;
                            this.projectStory = this.selectedProject.story;
                            this.projectDescription = this.selectedProject.description;

                            TweenLite.set(this.$refs['smallImage'], { alpha: 0 });

                            // 3. Fade in new data
                            TweenLite.to(this.$refs['infoContent'], 0.4, {
                                autoAlpha: 1,
                                transform: 'translateX(0)',
                                ease: Cubic.easeOut,
                                force3D: true,
                                onComplete: () => {
                                    TweenLite.to(this.$refs['smallImage'], 0.3, {
                                        autoAlpha: 1,
                                        ease: Linear.easeNone
                                    });
                                }
                            });
                        }
                    });
                });
            } else {
                TweenLite.set(this.$refs['smallImage'], { alpha: 0 });

                // 1. Update content
                this.projectYear = this.selectedProject.year;
                this.projectTitle = this.selectedProject.title;
                this.projectImage = this.selectedProject.image;
                this.projectUrl = this.selectedProject.url;
                this.projectStory = this.selectedProject.story;
                this.projectDescription = this.selectedProject.description;

                console.log('this.selectedProject.story ' + this.selectedProject.story);

                // 2. Open panel
                TweenLite.to(this.$refs['infoPanel'], 0.6, {
                    autoAlpha: 1,
                    transform: 'translateX(100%)',
                    ease: Cubic.easeInOut,
                    force3D: true
                });

                // 3. Fade in new data
                TweenLite.to(this.$refs['infoContent'], 0.4, {
                    autoAlpha: 1,
                    transform: 'translateX(0)',
                    ease: Cubic.easeOut,
                    force3D: true,
                    delay: 0.4,
                    onComplete: () => {
                        this.isOpen = true;

                        TweenLite.to(this.$refs['smallImage'], 0.3, {
                            autoAlpha: 1,
                            ease: Linear.easeNone
                        });
                    }
                });
            }
        },

        transitionOut() {
            if (this.isOpen) {
                // 1. Fade out current data
                TweenLite.to(this.$refs['infoContent'], 0.4, {
                    autoAlpha: 0,
                    transform: 'translateX(-20px)',
                    ease: Cubic.easeOut,
                    force3D: true
                });

                // 2. Close panel
                TweenLite.to(this.$refs['infoPanel'], 0.6, {
                    autoAlpha: 0,
                    transform: 'translateX(0)',
                    ease: Cubic.easeInOut,
                    force3D: true,
                    onComplete: () => {
                        this.isOpen = false;

                        TweenLite.set(this.$refs['smallImage'], { alpha: 0 });
                    }
                });

                this.$emit('infoClosed');
            }
        },

        getYearLabel(yearItem) {
            return yearItem === '2015' ? 'Pre-2016' : yearItem;
        }
    },

    mounted() {}
};
</script>

<style scoped lang="scss">
.info-panel {
    position: absolute;
    left: 0;
    z-index: 4000; // Make sure it acts as a modal above everything else
    opacity: 0;
    visibility: hidden;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 740px;
    background-color: #1f1f1f;
    margin: 0;
    transform: translateX(0);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 767px) {
        transform: translateX(0) !important;
    }

    @media screen and (min-width: 768px) {
        display: block;
        align-items: inherit;
        justify-content: inherit;
        z-index: 1000;
        border-radius: 0 7px 7px 0;
        margin: 0 0 0 -7px; // To account for 7px radius
        box-shadow: 0 0 15px rgba(#000, 0.2);
        right: inherit;
        bottom: inherit;
        top: 20px * 0.9;
        left: 20px * 0.9;
        width: 300px * 0.9;
        height: auto;
    }

    @media screen and (min-width: 1024px) {
        top: 20px;
        left: 20px;
        width: 300px;
    }

    .info-content {
        position: relative;
        opacity: 0;
        transform: translateX(-15px);
        padding: 25px * 0.8 20px * 0.8 25px * 0.8 20px * 0.8;

        @media screen and (max-width: 767px) {
            transform: translateX(0) !important;
            max-width: 340px;
        }

        @media screen and (min-width: 768px) {
            padding: 25px * 0.9 20px * 0.9 25px * 0.9 (20px * 0.9 + 7px); // To account for 7px radius
        }

        @media screen and (min-width: 1024px) {
            padding: 25px 20px 25px (20px + 7px); // To account for 7px radius
        }
    }

    .close-button {
        position: absolute;
        top: 20px * 0.8;
        right: 20px * 0.8;
        z-index: 1;

        @media screen and (min-width: 768px) {
            top: 20px * 0.9;
            right: 20px * 0.9;
        }

        @media screen and (min-width: 1024px) {
            top: 20px;
            right: 20px;
        }

        svg {
            width: 16px;
            height: 16px;
            display: block;
            transform: rotate(45deg);

            path {
                fill: #ff3a1e;
            }
        }
    }

    .project-image {
        position: relative;
        border-radius: 7px;
        overflow: hidden;
        width: 100%;
        height: auto;
        aspect-ratio: 480 / 280;
        margin: 0 0 25px * 0.8 0;
        display: block;
        background-color: #000;

        @media screen and (min-width: 768px) {
            margin: 0 0 25px * 0.9 0;
        }

        @media screen and (min-width: 1024px) {
            margin: 0 0 25px 0;
        }

        img {
            margin: 0;
            display: block;
            object-fit: cover;
            width: 100%;
            height: 100%;
        }
    }

    h2 {
        font-size: 16px * 0.8;
        margin: 0 0 25px * 0.8 0;
        letter-spacing: 0.5px;
        font-weight: 600;
        color: #00acc8;

        @media screen and (min-width: 768px) {
            font-size: 16px * 0.9;
            margin: 0 0 25px * 0.9 0;
        }

        @media screen and (min-width: 1024px) {
            font-size: 16px;
            margin: 0 0 25px 0;
        }
    }

    h3 {
        text-transform: uppercase;
        color: #727272;
        font-size: 12px * 0.8;
        font-weight: 500;
        letter-spacing: 1px;
        margin: 0 0 5px 0;

        @media screen and (min-width: 768px) {
            font-size: 12px * 0.9;
        }

        @media screen and (min-width: 1024px) {
            font-size: 12px;
        }
    }

    p {
        font-size: 14px * 0.8;
        margin: 0 0 20px * 0.8 0;
        line-height: 20px * 0.8;
        font-weight: 300;
        color: #fff;

        @media screen and (min-width: 768px) {
            font-size: 14px * 0.9;
            margin: 0 0 20px * 0.9 0;
            line-height: 20px * 0.9;
        }

        @media screen and (min-width: 1024px) {
            font-size: 14px;
            margin: 0 0 20px 0;
            line-height: 20px;
        }

        &:last-child {
            margin: 0;
        }
    }

    .project-button {
        position: relative;
        background: linear-gradient(#00acc8, darken(#00acc8, 7));
        border-radius: 5px;
        padding: 10px * 0.8 15px * 0.8;
        margin: 0;
        cursor: pointer;
        display: block;
        text-decoration: none;

        @media screen and (min-width: 768px) {
            padding: 10px * 0.9 15px * 0.9;
        }

        @media screen and (min-width: 1024px) {
            padding: 10px 15px;
        }

        span {
            font-size: 14px * 0.8;
            line-height: 14px * 0.8;
            letter-spacing: 0.5px;
            font-weight: 500;
            color: #fff;
            text-transform: capitalize;
            padding: 0;
            transition: all 0.35s ease 0s;

            @media screen and (min-width: 768px) {
                font-size: 14px * 0.9;
                line-height: 14px * 0.9;
            }

            @media screen and (min-width: 1024px) {
                font-size: 14px;
                line-height: 14px;
            }
        }

        svg {
            position: absolute;
            top: 50%;
            right: 15px;
            transform: translateY(-50%);
            height: auto;
            fill: #fff;
            pointer-events: none;
            transition: all 0.35s ease 0s;

            &.arrow-icon {
                width: 10px;
            }

            &.email-icon {
                width: 16px;
            }
        }
    }
}
</style>
